/**
 * Determines whether to use white or black text based on background color brightness
 *
 * @param hexColor - Hex color string (e.g., '#RRGGBBAA' or '#RRGGBB')
 * @returns '#FFFFFF' for white text or '#000000' for black text
 */
export function getContrastColor(hexColor: string): string {
  // Remove # if present
  const hex = hexColor.replace('#', '');

  // Parse RGB values (ignore alpha if present)
  const r = Number.parseInt(hex.substring(0, 2), 16);
  const g = Number.parseInt(hex.substring(2, 4), 16);
  const b = Number.parseInt(hex.substring(4, 6), 16);

  // Calculate relative luminance using the formula from WCAG
  // https://www.w3.org/TR/WCAG20/#relativeluminancedef
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // If luminance is greater than 0.5, the background is bright, so use black text
  // Otherwise, use white text
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}
